import Vue from "vue";
import Router from "vue-router";
import Home from "./views/Home.vue";
import Journalist from "./views/Journalist.vue";
import Network from "./views/Network.vue";
import Publication from "./views/Publication.vue";
import AdvancedSearch from "./views/AdvancedSearch.vue";
import Podcast from "./views/Podcast.vue";
import Episode from "./views/Episode.vue";
import Transcript from "./views/Transcript.vue";

Vue.use(Router);

export default new Router({
  mode: "history",
  base: process.env.BASE_URL,
  routes: [{
      path: "/",
      name: "home",
      component: Home,
    },
    {
      path: "/periodista/:name",
      name: "periodista",
      component: Journalist,
    },
    {
      path: "/red/:name",
      name: "red",
      component: Network,
    },
    {
      path: "/publicacion/:index/periodista/:name",
      name: "publicacion",
      component: Publication,
    },
    {
      path: "/busqueda-avanzada",
      name: "busqueda-avanzada",
      component: AdvancedSearch,
    },
    /*{
      path: "/voces-silenciadas",
      name: "podcast",
      component: Podcast
    },
    {
      path: "/voces-silenciadas/:id/:name",
      name: "episodio",
      component: Episode
    },
    {
      path: "/voces-silenciadas/:id/:name/transcripcion",
      name: "transcripcion",
      component: Transcript
    }*/
  ],
});